import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import GameModeViewPage from "../components/GameModeViewPage";
import useMessagesSocket from "../hoc/useMessagesSocket";
import useMessagesHandler from "../hoc/useMessagesHandler";

export const Routers = () => {
    useMessagesSocket();
    useMessagesHandler();
  return (
      <Router>
        <Routes>
          <Route path="/" element={ <GameModeViewPage />} />
        </Routes>
      </Router>
  );
};

export default Routers;
